
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/customer-care/accessibility",
      function () {
        return require("private-next-pages/help/customer-care/accessibility/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/customer-care/accessibility"])
      });
    }
  